import { createWorkflowStage } from './create'
import { deleteWorkflowStage } from './delete'
import { readWorkflowStage } from './read'
import { updateWorkflowStage } from './update'

export const workflowStages = {
  create: createWorkflowStage,
  delete: deleteWorkflowStage,
  readSingle: readWorkflowStage,
  update: updateWorkflowStage,
}
